import { createSlice } from '@reduxjs/toolkit';
import { PackageProvider } from '../../../../pb/responses/v1/package_providers_response_pb';
import { getPackageProviders } from './package-providers.actions';

export interface PackageProvidersState {
    packageProviders: PackageProvider[] | null;
    fetching: boolean;
}

const initialState: PackageProvidersState = {
    packageProviders: null,
    fetching: false,
};

const packageProvidersSlice = createSlice({
    name: 'packageProviders',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPackageProviders.pending, (state) => {
                state.fetching = true;
            })
            .addCase(getPackageProviders.fulfilled, (state, action) => {
                state.packageProviders = action.payload;
                state.fetching = false;
            })
            .addCase(getPackageProviders.rejected, (state) => {
                state.fetching = false;
            });
    },
});

export default packageProvidersSlice.reducer;
